import * as React from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import {
  $flushTicketNotesAutoSave,
  $ticketNotesFormById,
  $updateTicketNotesField,
  DEFAULT_NOTES_FORM,
} from '~/modules/trade/_state/scaleTicketInboundNotesForm.state';
import { $scaleTicketDetail } from '~/modules/trade/_state/scaleTicketPro.state';
import { EntityTabNotes } from '~/shared/components/EntityTabNotes';

export const InboundTicketTabNotes = () => {
  const ticketData = useAtomValue($scaleTicketDetail);
  const ticket = ticketData?.data;

  const notesFormMap = useAtomValue($ticketNotesFormById);
  const notesForm =
    (ticket?.id ? notesFormMap.get(ticket.id) : undefined) ??
    DEFAULT_NOTES_FORM;
  const updateNotesField = useSetAtom($updateTicketNotesField);
  const flushNotesAutoSave = useSetAtom($flushTicketNotesAutoSave);

  const isReadonly = ticket?.status === 'Voided';

  const handleChange = React.useCallback(
    (notes: { internalNotes: string; externalNotes: string }) => {
      if (!ticket?.id) return;
      updateNotesField({
        field: 'internalNotes',
        value: notes.internalNotes,
        ticketId: ticket.id,
      });
      updateNotesField({
        field: 'externalNotes',
        value: notes.externalNotes,
        ticketId: ticket.id,
      });
    },
    [ticket?.id, updateNotesField],
  );

  const handleSave = React.useCallback(async () => {
    if (!ticket?.id) return;
    flushNotesAutoSave(ticket.id);
  }, [ticket?.id, flushNotesAutoSave]);

  if (!ticket) {
    return null;
  }

  return (
    <EntityTabNotes
      key={ticket.id}
      className="@InboundTicketTabNotes p-0"
      counterparty="supplier"
      isReadonly={isReadonly}
      internalNotes={notesForm.internalNotes ?? ''}
      externalNotes={notesForm.externalNotes ?? ''}
      onSave={handleSave}
      onChange={handleChange}
    />
  );
};
